
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import buscador from './buscador.vue';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { ModoDeVistaActual } from '@/__env/main';
    var deferredPrompt: any = null;

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        async mounted()
        {
            await this.Controlador.Iniciar();

            this.Refrescar();

            await Wait( 300 );
            this.ModoDeVistaActual = ModoDeVistaActual;

            if ( this.ModoDeVistaActual == 'browser tab' )
            {
                Utiles.Instalar( true );
            }



        }

        Instalar()
        {
            Utiles.Instalar( true );
        }

        public ModoDeVistaActual: string = '';
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


    }
